import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'
import SUBUSER_PERMISSION_SLUGS from '@/constants/authorization/subuser-permission-slugs'

function productReservationAddonGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  if (store.getters['subscription/isProductReservationPurchased']) {
    return next()
  }

  if (store.getters['permissions/hasSubuserPermission'](SUBUSER_PERMISSION_SLUGS.ORDERS_RESERVATION_ORDERS_VIEW)) {
    return next()
  }

  return next({ name: 'error-404' })
}

export default productReservationAddonGuard
